import { render, staticRenderFns } from "./Share&SaveCouponListComponent.vue?vue&type=template&id=0c1c55b3"
import script from "./Share&SaveCouponListComponent.vue?vue&type=script&lang=js"
export * from "./Share&SaveCouponListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports